import Header from "../components/Header";
import Footer from "../components/Footer";

const content = {
  mentions: {
    title: "Mentions légales",
    sections: [
      { h: "1. Informations légales", body: (
        <>
          <p className="text-muted-foreground leading-relaxed mb-4">Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique.</p>
          <div className="bg-card border border-border rounded-lg p-6 space-y-3">
            <p><strong>Raison sociale :</strong> Mac-Support Pro Solution</p>
            <p><strong>Siège social :</strong> 60 rue François 1er, 75008 Paris, France</p>
            <p><strong>SIREN :</strong> 101 168 284</p>
            <p><strong>SIRET :</strong> 101 168 284 00012</p>
            <p><strong>Code NAF / APE :</strong> 6203Z</p>
            <p><strong>TVA intracommunautaire :</strong> FR 12 101168284</p>
            <p><strong>Téléphone :</strong> <a href="tel:+33189707560" className="text-primary hover:underline">+33 1 89 70 75 60</a></p>
            <p><strong>Email :</strong> <a href="mailto:contact@macsupport-solution.com" className="text-primary hover:underline">contact@macsupport-solution.com</a></p>
          </div>
        </>
      )},
      { h: "2. Directeur de publication", body: <p className="text-muted-foreground leading-relaxed">Le directeur de la publication est le représentant légal de la société Mac-Support Pro Solution.</p> },
      { h: "3. Hébergement", body: <p className="text-muted-foreground leading-relaxed">Le site est hébergé par un prestataire technique dont les coordonnées sont disponibles sur demande.</p> },
      { h: "4. Propriété intellectuelle", body: <p className="text-muted-foreground leading-relaxed">L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous droits réservés.</p> },
      { h: "5. Protection des données", body: <p className="text-muted-foreground leading-relaxed">Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Contact : <a href="mailto:contact@macsupport-solution.com" className="text-primary hover:underline">contact@macsupport-solution.com</a></p> },
    ],
  },
  privacy: {
    title: "Politique de confidentialité",
    sections: [
      { h: "Collecte des données", body: <p className="text-muted-foreground leading-relaxed">Nous collectons uniquement les données nécessaires à la fourniture de nos services : nom, email, numéro de téléphone et informations sur votre parc informatique.</p> },
      { h: "Utilisation des données", body: <p className="text-muted-foreground leading-relaxed">Vos données sont utilisées exclusivement dans le cadre de nos prestations et ne sont jamais revendues à des tiers.</p> },
      { h: "Vos droits", body: <p className="text-muted-foreground leading-relaxed">Vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Contactez-nous à <a href="mailto:contact@macsupport-solution.com" className="text-primary hover:underline">contact@macsupport-solution.com</a>.</p> },
    ],
  },
  cgv: {
    title: "Conditions Générales de Vente",
    sections: [
      { h: "1. Objet", body: <p className="text-muted-foreground leading-relaxed">Les présentes CGV régissent les relations entre Mac-Support Pro Solution et ses clients professionnels.</p> },
      { h: "2. Prestations", body: <p className="text-muted-foreground leading-relaxed">Nos prestations comprennent la maintenance, l'assistance technique et l'infogérance de parcs informatiques Apple.</p> },
      { h: "3. Tarifs et paiement", body: <p className="text-muted-foreground leading-relaxed">Les tarifs sont indiqués hors taxes. Le paiement s'effectue par virement bancaire à réception de facture.</p> },
      { h: "4. Durée", body: <p className="text-muted-foreground leading-relaxed">Les contrats annuels sont conclus pour une durée de 12 mois, renouvelables par tacite reconduction.</p> },
    ],
  },
  cookies: {
    title: "Politique de cookies",
    sections: [
      { h: "Qu'est-ce qu'un cookie ?", body: <p className="text-muted-foreground leading-relaxed">Un cookie est un petit fichier texte déposé sur votre appareil lors de la visite d'un site web.</p> },
      { h: "Cookies utilisés", body: <p className="text-muted-foreground leading-relaxed">Nous utilisons des cookies nécessaires au fonctionnement du site, ainsi que des cookies d'analyse (avec votre consentement).</p> },
      { h: "Gérer vos préférences", body: <p className="text-muted-foreground leading-relaxed">Vous pouvez gérer vos préférences via le bandeau de cookies affiché lors de votre première visite.</p> },
    ],
  },
};

export default function LegalPage({ type }) {
  const data = content[type];
  return (
    <main className="min-h-screen flex flex-col">
      <Header />
      <section className="flex-1 pt-32 pb-16 lg:pt-40 lg:pb-24">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-8">{data.title}</h1>
            <div className="space-y-8">
              {data.sections.map((s, i) => (
                <section key={i}>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{s.h}</h2>
                  {s.body}
                </section>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
